var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94073 2.64323C9.38854 1.96408 8.78967 1.5 8 1.5C7.21033 1.5 6.61144 1.96408 6.05923 2.64323C5.6477 3.14939 5.21248 3.83738 4.70442 4.68294L4.17057 5.58073L2.88736 7.74413L2.85562 7.79767C2.08985 9.08867 1.48545 10.1076 1.14908 10.9297C0.806668 11.7666 0.683348 12.5372 1.08267 13.2422L1.16145 13.3698C1.57365 13.9833 2.26224 14.2445 3.09895 14.3691C3.97793 14.5 5.16463 14.5 6.668 14.5H6.7168H9.2832H9.332C10.8353 14.5 12.0221 14.5 12.901 14.3691C13.7935 14.2362 14.5176 13.9478 14.9173 13.2422L14.9863 13.1094C15.3005 12.4407 15.1719 11.7143 14.8509 10.9297C14.5951 10.3046 14.1847 9.56553 13.666 8.67967L13.1126 7.74413L11.8294 5.58073L11.7985 5.52871C11.0634 4.28926 10.4819 3.30885 9.94073 2.64323Z",
    fill: "#D5864E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 9.00001V6.00001C7.33337 5.63182 7.63184 5.33334 8.00004 5.33334C8.36824 5.33334 8.66671 5.63182 8.66671 6.00001V9.00001C8.66671 9.36821 8.36824 9.66668 8.00004 9.66668C7.63184 9.66668 7.33337 9.36821 7.33337 9.00001Z",
    fill: "#FEF4EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 11.3347V11.3281C7.33337 10.9599 7.63184 10.6615 8.00004 10.6615C8.36824 10.6615 8.66671 10.9599 8.66671 11.3281V11.3347C8.66671 11.7028 8.36824 12.0013 8.00004 12.0013C7.63184 12.0013 7.33337 11.7028 7.33337 11.3347Z",
    fill: "#FEF4EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3c4984efc020a5a870eb2ebeb69d46eb.svg";
export { ForwardRef as ReactComponent };